import Badge from "@/features/badge/components/Badge";
import Translation from "@/features/translation/components/Translation";

interface VehicleSnippetBadgeProps {
    vehicleGroupId: number;
}

function VehicleSnippetBadge({ vehicleGroupId }: VehicleSnippetBadgeProps) {
    if (vehicleGroupId === 2) {
        return (
            <Badge
                className="gb--vehicle-card__badge"
                left
                primary
            >
                <span>
                    <Translation translationKey='transfers_banner.labels.popular' />
                </span>
            </Badge>
        );
    }

    if (vehicleGroupId === 6) {
        return (
            <Badge
                className="gb--vehicle-card__badge"
                left
                primary
            >
                <span>
                    <Translation translationKey='transfers_banner.labels.best_value' />
                </span>
            </Badge>
        );
    }

    return null;
}

export default VehicleSnippetBadge;
